
import {
  computed, defineComponent, inject, onMounted, Ref, ref, watch,
} from 'vue';
import { Form, defineRule } from 'vee-validate';
/* eslint-disable import/no-cycle */
import { useMainStore } from '@/store/mainStore';
import { IEmail } from '@/types/interfaces';
import AppHeader from '@/components/AppHeader.vue';
import AppInput from '@/components/UI/AppInput.vue';
import AppButton from '@/components/UI/AppButton.vue';
import ValidationService from '@/services/ValidationService';
/* eslint-disable import/no-cycle */
import AuthService from '@/modules/auth/services/AuthService';
import MonitoringService from '@/services/MonitoringService';

defineRule('required', (value:string) => ValidationService.isNotEmpty(value) || 'This field is required');
// defineRule('email', (value: string) => ValidationService.isEmail(value) || 'Email is not valid');

export default defineComponent({
  components: {
    AppInput, AppButton, AppHeader, Form,
  },
  setup() {
    const schema = { email: 'required' };
    const resetForm = ref(true);
    const dataLoading = ref(false);
    const errors = ref('');
    const mainStore = useMainStore();
    const inputEmail: Ref<any | null> = ref(null);
    const emailError = ref('');
    // eslint-disable-next-line @typescript-eslint/ban-types
    const $localize = inject('$localize') as Function;
    const emailInputValue = computed(() => inputEmail.value?.value);

    function onSubmit(values: IEmail) {
      // eslint-disable-next-line no-param-reassign
      values.email = values.email.trim();
      if (!ValidationService.isEmail(values.email)) {
        emailError.value = $localize('error.email');
        return;
      }
      dataLoading.value = true;
      // AuthService.resetPassword(values).then((response) => {
      //   if (response.success || response.errorKey === 'NO_USER_EXISTS_WITH_SUCH_EMAIL') {
      //     resetForm.value = false;
      //   }
      // }).finally(() => { dataLoading.value = false; });
      const payload = {
        email: emailInputValue.value.trim(),
      };
      AuthService.sendLoginEmailLink(payload).then((response) => {
        if (response.errorKey === 'NO_USER_EXISTS_WITH_SUCH_EMAIL') {
          // errors.value = `Please check your email. If you have an account associated with ${values.email} you will receive a letter with further instructions.`;
          resetForm.value = false;
        }
        if (response.success) {
          resetForm.value = false;
        }
      }).finally(() => { dataLoading.value = false; });
    }

    watch(() => emailInputValue.value, (nv, ov) => {
      if ((nv !== ov) && (ov !== null)) {
        emailError.value = '';
      }
    });

    onMounted(() => {
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      mainStore,
      schema,
      resetForm,
      dataLoading,
      errors,
      onSubmit,
      emailError,
      inputEmail,
    };
  },
});
